class PaginationRange extends HTMLElement {
  static observedAttributes = ['start-number', 'end-number'];

  attributeChangedCallback(name, oldValue, newValue) {
    // Prevent unnecessary updates if the value hasn't changed
    if (oldValue === newValue) return;

    switch (name) {
      case 'start-number':
        this.updateStartNumber(newValue);
        break;
      case 'end-number':
        this.updateEndNumber(newValue);
        break;
    }
  }

  updateStartNumber(newValue) {
    const rangeStart = this.querySelector('[data-range-start]');
    rangeStart.textContent = newValue;
  }

  updateEndNumber(newValue) {
    const rangeEnd = this.querySelector('[data-range-end]');
    rangeEnd.textContent = newValue;
  }
}

customElements.define('pagination-range', PaginationRange);
